import React, { useState } from 'react';
import axios from 'axios';

const ContactForm = ({ onFormSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setError(null);

  try {
    const API_URL = process.env.NODE_ENV === 'production' 
      ? 'https://yasserv.com.br/processa_contato.php'
      : 'https://yasserv.com.br/processa_contato.php'; // Mesmo URL para produção e desenvolvimento

    const response = await axios.post(API_URL, formData, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    if (response.data.success) {
      onFormSubmit(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    }
  } catch (err) {
    setError(err.response?.data?.error || 'Erro ao enviar formulário. Tente novamente.');
  } finally {
    setIsLoading(false);
  }
};

  return (
    <form className="w-75" onSubmit={handleSubmit}>
      {error && <div className="alert alert-danger">{error}</div>}
      
      <div className="mb-3">
        <label className="form-label">Nome *</label>
        <input
          type="text"
          name="name"
          placeholder="Digite seu nome"
          className="form-control"
          value={formData.name}
          onChange={handleChange}
          required
          disabled={isLoading}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Email</label>
        <input
          type="email"
          name="email"
          className="form-control"
          placeholder="email@email.com.br"
          value={formData.email}
          onChange={handleChange}
          disabled={isLoading}
        />
      </div>
      
      <div className="mb-3">
        <label className="form-label">Telefone/WhatsApp *</label>
        <input
          type="tel"
          name="phone"
          className="form-control"
          value={formData.phone}
          onChange={handleChange}
          required
          placeholder="(11) 99999-9999"
          disabled={isLoading}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Mensagem</label>
        <textarea
          name="message"
          className="form-control"
          rows="4"
          value={formData.message}
          onChange={handleChange}
          placeholder="Conte-nos como podemos ajudar..."
          disabled={isLoading}
        ></textarea>
      </div>
      
      <button 
        type="submit" 
        className="btn btn-primary w-100 mb-5"
        disabled={isLoading}
      >
        {isLoading ? 'Enviando...' : 'Enviar Mensagem'}
      </button>
    </form>
  );
};

export default ContactForm;